import React, { Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Image } from '../../../AbstractElements';
import { dynamicImage } from '../../../Service';

import ReactPlayer from 'react-player';

interface ViewElementProps {
  element: Element;
}

interface Element {
  id: number;
  type: string;
  subject: string;
  description: string;
  file_id?: string;
}

// CollapsibleText component as previously defined or imported
const CollapsibleText: React.FC<{ subject: string, description: string }> = ({ subject, description }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div>
      <div onClick={toggleOpen} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <div style={{
          transform: !isOpen ? 'rotate(0deg)' : 'rotate(90deg)',
          transition: 'transform 0.3s',
          marginRight: '5px'
        }}>
          ▶{/* This is the triangle icon */}
        </div>
        <strong>{subject || "Default Text"}</strong>
      </div>
      {isOpen && <div style={{ paddingLeft: '20px', marginTop: '5px' }}>
        {description || "This is just set as default."}
      </div>}
    </div>
  );
};

const ViewElement: React.FC<ViewElementProps> = ({ element }) => {
  return (
    <div
      id={`element-${element.id}`}
      className='my-3 mx-4'
      style={{
        position: 'relative',
        color: '#fff', padding: '10px', boxSizing: 'border-box'
      }}>
      {element.type === 'dropdown' ?
        <CollapsibleText subject={element.subject} description={element.description} />
        : null}
      {element.type === 'text' ?
        <div>{element.description || "This is just set as default."}</div>
        : null}
      {element.type === 'video' ?
        element.file_id ?
          <ReactPlayer
            url={`${process.env.REACT_APP_BACKEND_URL}/page/video/${element.file_id}`}
            controls
            width='100%'
            height={"auto"}
          /> : <video src="" controls width={"100%"}></video>
        : null}
      {element.type === 'image' ?
        element.file_id ?
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/page/image/${element.file_id}`}
            width='100%'
            height={"auto"}
          /> :
          <div className='d-flex justify-content-center'>
            <Image className="img-fluid"
              src={dynamicImage("logo/gallery.png")}
              alt="logo"
              style={{
                width: "50%",
                marginInline: 'auto',
              }} />
          </div>
        : null}
    </div>
  );
};

interface CanvasAreaProps {
  elements: Element[];
}

interface Element {
  id: number;
  type: string;
  subject: string;
  description: string;
  url?: string;
}

const PageView: React.FC<CanvasAreaProps> = ({ elements }) => {
  return (
    <div style={{ width: '100%', overflow: 'auto' }}>
      <div style={{ background: "black", maxWidth: 600, marginInline: "auto", maxHeight: "calc(100vh - 400px)", overflow: "auto" }} >
        <CardBody
          className="pb-5"
          style={{ maxWidth: "100%", minHeight: "calc(100vh - 400px)" }}
        >
          <div >
            <div className='d-flex justify-content-center my-4'>
              <Image className="img-fluid for-light" src={dynamicImage("logo/logo.png")} alt="logo" style={{ width: '25%' }} />
            </div>
            {elements.map((element, index) => (
              <Fragment key={index + 'element'}>
                <ViewElement element={element} />
              </Fragment>
            ))}
          </div>
        </CardBody>
      </div>
    </div>
  );
};

export default PageView;
